
  <div class="job-posts placements agreements">
    <div class="card skillassest-form">
      <div class="card-header wh-header card-title-schedule-bb card-title-schedule-bl padding-l-0px margin-bottom-10px padding-bottom padding-top-5">
        <div class="row margin-left-zero">
          <div class="col-md-2">
            Schedule

 

          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-3 col-sm-3 padding-right padding-left-9px">
                <div class="form-group  margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-3 col-sm-3 text-align-right">
                      <label for="diaplayName " class="font-size-14px margin-bottom-0px">From</label>
                    </div>

                    <div class="col-md-8 col-sm-4 padding-l-0px">
                      <div class="date-form">
                        <input class="form-control form-border2" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                               name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                                  (ngModelChange)="dataChanged($event)"
                               >

                        <a (click)="d.toggle()" class="nav-link-hand">
                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                        </a>

                      </div>



                    </div>
                  </div>

                </div>
              </div>
              <div class="col-md-3 col-sm-3 padding-right padding-left-9px">
                <div class="form-group  margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-3 col-sm-3 text-align-right">
                      <label for="diaplayName " class="font-size-14px margin-bottom-0px">To</label>
                    </div>

                    <div class="col-md-8 col-sm-4 padding-l-0px">
                      <div class="date-form">
                        <input class="form-control form-border2" placeholder="To Date" [minDate]="minDate" [maxDate]="maxDate"
                               name="SelectedToDate" [(ngModel)]="SelectedToDate" ngbDatepicker #d1="ngbDatepicker"
                                  (ngModelChange)="dataChanged($event)" >

                        <a (click)="d1.toggle()" class="nav-link-hand">
                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                        </a>

                      </div>



                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
         

         
          <div class="col-md-4 float-right" hidden>
            <button type="button"
                    class="btn  actions-btn-prime2 benfits-button font-size month-badge margin-left-5px">
              month
            </button><button type="button"
                             class="btn  actions-btn-prime2 benfits-button font-size month-badge2 margin-left-5px">
              week
            </button>
            <button type="button"
                    class="btn  actions-btn-prime2 benfits-button font-size month-badge3">
              day
            </button>

          </div>
        </div>
        
        

      </div>
      <div class="card-body padding-top">
        <div class="card">
          <div class="card-body padding-top padding-bottom">
            <div class="row">
              <div class="col-md-3 col-sm-3 padding-right padding-left-9px">
                <div class="form-group  margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-3 col-sm-3 text-align-right">
                      <label for="diaplayName " class="font-size-14px margin-bottom-0px">Location</label>
                    </div>

                    <div class="col-md-8 col-sm-4 padding-l-0px">
                      <CustomDataByRequestType RequestedType="ActorPreferredLocations"
                                               CustomType="ActorPreferredLocations"
                                               id="ActorPreferredLocations.SelectedLocation"
                                               [(ngModel)]="SelectedLocationCode"
                                               name="ActorPreferredLocations.SelectedLocation"  
                                               (keyChange)="onSelectedLocationChange($event)"
                                               #SelectedLocation_="ngModel"
                                               [ActorCode]="ActorCode"
                                            
                                               >
                      </CustomDataByRequestType>

                      <!--<CodeTypeValue CodeType="STATE"></CodeTypeValue>-->
                      <!--id="CurrentActorPersonalDetailInfoRequest.MaritalStatus"
  [(ngModel)]="CurrentActorPersonalDetailInfoRequest.MaritalStatus" SelectedValue="{{CurrentActorPersonalDetailInfoRequest.MaritalStatus}}"
  name="CurrentActorPersonalDetailInfoRequest.MaritalStatus"></CodeTypeValue>-->

                    </div>
                  </div>

                </div>
              </div>

              <div class="col-md-3 col-sm-3 padding-l-0px " hidden>
                <div class="form-group  margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-3 col-sm-3 text-align-right padding-l-0px">
                      <label for="diaplayName" class="font-size-14px margin-bottom-0px">Hospital</label>
                    </div>

                    <div class="col-md-8  col-sm-4 padding-l-0px">
                      <CodeTypeValue CodeType="STATE"></CodeTypeValue>
                                     <!--id="CurrentActorPersonalDetailInfoRequest.MaritalStatus"
                                     [(ngModel)]="CurrentActorPersonalDetailInfoRequest.MaritalStatus" SelectedValue="{{CurrentActorPersonalDetailInfoRequest.MaritalStatus}}"
                                     name="CurrentActorPersonalDetailInfoRequest.MaritalStatus"-->

                    </div>
                  </div>

                </div>

              </div>
              
                <!--<div class="col-md-3 padding-l-0px float-right ">
                  <div class="form-group  margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right padding-l-0px">
                        <label for="diaplayName" class="font-size-14px margin-bottom-0px">Status</label>
                      </div>

                      <div class="col-md-8 padding-l-0px">
                        <CodeTypeValue CodeType="STATE"></CodeTypeValue>
                        

                      </div>
                    </div>

                  </div>

                </div>
                <div class="col-md-3 padding-l-0px padding-right">
                  <div class="float-right">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  </div>

                </div>-->
              
              <div class="offset-3 col-md-6 col-sm-3 float-right" >
                <div class="row">
                  
                    <div class="col-md-4  col-sm-3 text-align-right " hidden>
                      <label for="diaplayName" class="font-size-14px margin-bottom-0px">Status</label>
                    </div>
                    <div class="col-md-4 col-sm-2 form-group margin-bottom-0px padding-left-zero" hidden>
                      <CodeTypeValue CodeType="JOBST"></CodeTypeValue>
                    </div>
                 
                
                  <div class="offset-8 col-md-4 col-sm-3 form-group margin-bottom-0px padding-right">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  </div>
                </div>

              </div>
            </div>
            </div>
            <div class="card">
              <div class="card-header Shift-Calendar padding-left-16px">
                Shifts Calendar
                <ul class="nav navbar-nav float-right margin-top-4px">
                  <li class="dropdown ">
                    <a href="#" class="dropdown-toggle color-datacolor" data-toggle="dropdown"><i class="fas fa-info-circle"></i> <!--<span class="glyphicon glyphicon-user pull-right"></span>--></a>
                    <ul class="dropdown-menu drop-down-menu2">
                      <!--<li>
    <div class="row">
      <div class="col-md-8 padding-right-0px margin-left-10px">
        <a  data-toggle="tooltip" data-placement="bottom" class="badge badge-Applied color-datacolor text-decoration font-weight-normal font-size-14">
          <i class="nav-link-hand  color-Forwarded font-style-initial margin-right-8px">
            A
          </i>Assigned
        </a>
      </div>
    </div>


  </li>-->
                      <!--<li>
    <div class="row">
      <div class="col-md-8 padding-right-0px margin-left-10px">
        <a  class="color-datacolor font-weight-normal text-decoration font-size-14">
          <i class="fas fa-arrow-alt-circle-right color-Forwarded nav-link-hand margin-right-3px">
          </i>Forwarded
        </a>
      </div>
    </div>

  </li>-->
                      <li>
                        <div class="row">
                          <div class="col-md-8 padding-right-0px margin-left-10px">
                            <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                              <i class="fas fa-circle color-default nav-link-hand  ">
                              </i> Booked
                            </a>
                          </div>
                        </div>


                      </li>
                      <li>
                        <div class="row">
                          <div class="col-md-8 padding-right-0px margin-left-10px">
                            <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                              <i class="fas fa-circle color-Assign nav-link-hand  ">
                              </i> Pending
                            </a>
                          </div>
                        </div>


                      </li>
                      <li>
                        <div class="row">
                          <div class="col-md-8 padding-right-0px margin-left-10px">
                            <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                              <i class="fas fa-circle color-Rejected nav-link-hand  ">
                              </i> Rejected
                            </a>
                          </div>
                        </div>


                      </li>

                      <!--<li>
    <div class="row">
      <div class="col-md-8 padding-right-0px margin-left-10px">
        <a  class="color-datacolor font-weight-normal text-decoration font-size-14">
          <i class="fas fa-map-pin color-Forwarded nav-link-hand font-size-14 margin-right-4px">

          </i>Pinned
        </a>
      </div>
    </div>

  </li>

  <li>
    <div class="row">
      <div class="col-md-12 padding-right-0px margin-left-10px">
        <a  class="color-datacolor font-weight-normal text-decoration font-size-14">
          <i class="fas fa-certificate color-default nav-link-hand margin-right-3px">

          </i>Release Offer
        </a>
      </div>
    </div>

  </li>
  <li>
    <div class="row">
      <div class="col-md-12 padding-right-0px margin-left-10px">
        <a  class="color-datacolor font-weight-normal text-decoration font-size-14">
          <i class="fas fa-long-arrow-alt-down color-Forwarded nav-link-hand margin-right-3px">

          </i>Shift Request
        </a>
      </div>
    </div>

  </li>-->

                    </ul>
                  </li>
                </ul>
                <button type="button" (click)="Refresh()" class="btn btn-primary btn-sm float-right" id="filter" title="Refresh"><i class="fas fa-sync nav-link-hand"></i></button>

              </div>
              <div class="card-body padding-top">
                <!--<nav>
                  <div class="nav nav-tabs ">
                    <a class="nav-item nav-link btn" role="tab"
                       data-toggle="pill" href="#ApplicantInfo">
                      Schedule
                    </a>
                    <a class="nav-link  btn" role="tab"
                       data-toggle="pill" href="#profileinfo">Pending Shifts</a>
                    <a class="nav-link  btn" role="tab"
                       data-toggle="pill" href="#profileinfo">Open Shifts</a>

                  </div>
                </nav>-->
                <!--<div class="card alerts-note-form jp">
                  <div class="card-body">
                    <div class="tab-content hcare-tab-content">
                      <div class="tab-pane  container" id="ApplicantInfo" role="tabpanel">-->

                        <div class="table-component">
                          <div class="table-responsive overflow-x">
                            <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->

                            <table class="table table-striped margin-left-5px"

                                   cols="auto,2*,*,*,*,*,*,*,*,*">
                            
                              <thead class="">
                                <tr>

                                  <th class="text-align-center">Date</th>
                                  <th>Job Id</th>
                                  <th class="text-align-left" [class]="selectedClass('HospitalState')" (click)="changeSorting('HospitalState')">Location</th>
                                  <th class="text-align-left" [class]="selectedClass('HospitalDisplayName')" (click)="changeSorting('HospitalDisplayName')">Hospital</th>
                                  <th scope="col" class="text-align-left" [class]="selectedClass('ShiftType')" (click)="changeSorting('ShiftType')">Shift</th>
                                  <th scope="col" class="text-align-left" [class]="selectedClass('StaffType')" (click)="changeSorting('StaffType')">Role</th>
                                  <th scope="col" class="text-align-left" [class]="selectedClass('Specialty')" (click)="changeSorting('Specialty')">Speciality</th>
                                  <th scope="col" class="text-align-left" [class]="selectedClass('Department')" (click)="changeSorting('Department')">Department</th>
                                  <th  class="text-align-right"  (click)="changeSorting('ProposedCopmpensation')">Pay Rate</th>
                                  <th scope="col" class="text-align-center">Status</th>
                                  <th scope="col"></th>
                                



                                </tr>
                              </thead>

                              <tbody class="table-body" *ngIf="pdata">
                                <!--AppendJobApplicationsInfoByRegistryOnDemandController
       | orderby : convertSorting()
                                    -->
                                <tr *ngFor="let l of pdata;let RowIndex = index">
                                  <td class="td-width td-padding border-right background-2">

                                    {{l.JoinByDate | date: 'MM-dd-yyyy'}}
                                  </td>
                                  <td>{{l.JobFormattedCode}}</td>

                                  <td class=" td-padding text-align-left">{{l. HospitalState}}</td>
                                  <td class=" td-padding text-align-left ">{{l. HospitalDisplayName}}</td>
                                  <td class=" td-padding text-align-left">{{l.ShiftType}}</td>
                                  <td class=" td-padding text-align-left">{{l.StaffType}}</td>
                                  <td class=" td-padding text-align-left">
                                    {{l.Specialty}}
                                  </td>
                                  <td class=" td-padding text-align-left">{{l.Department}}</td>
                                  <td class=" text-align-right">{{l.ProposedCopmpensation}}</td>
                                  <td class="text-align-center">
                                    <div [ngSwitch]="l.ApplicationStatus">

                                      <!--<a href="#" data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}" class="badge badge-Applied">
    <i *ngSwitchCase="'Assigned'"
       class="fas fa-circle color-Assign nav-link-hand font-size-14">
      A
    </i>
  </a>-->
                                      <!--<a href="#" data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}" class="badge badge-Applied">
    <i *ngSwitchCase="'Assigned'"
       class="fas fa-circle color-Assign nav-link-hand font-size-14">
      A
    </i>
  </a>-->


                                      <a data-toggle="tooltip" data-placement="bottom" title="Booked">
                                        <!--<i *ngSwitchCase="'Assigned'"-->
                                        <i *ngSwitchCase="'Released Offer'"
                                           class="fas fa-circle color-default nav-link-hand font-size-14">
                                        </i><!--{{l.ApplicationStatus}}-->
                                      </a>
                                      <a data-toggle="tooltip" data-placement="bottom" title="Booked">
                                        <!--<i *ngSwitchCase="'Assigned'"-->
                                        <i *ngSwitchCase="'Assigned'"
                                           class="fas fa-circle color-default nav-link-hand font-size-14">
                                        </i>
                                      </a>
                                      <a data-toggle="tooltip" data-placement="bottom" title="Unavailable">
                                        <i *ngSwitchCase="'Rejected'"
                                           class="fas fa-circle color-Rejected nav-link-hand font-size-14">
                                        </i>
                                      </a>
                                      <!--<a data-toggle="tooltip" data-placement="bottom" title="{{l.ApplicationStatus}}" class="badge badge-Applied">
    <i *ngSwitchCase="'Assigned'"
       class="nav-link-hand font-size-14 color-Forwarded font-style-initial">
      A
    </i>
  </a>-->



                                      <a data-toggle="tooltip" data-placement="bottom"
                                         *ngSwitchCase="'Shift Request'"
                                         title="Unavailable">
                                        <i *ngIf="l.NurseResponse == 'Rejected' "
                                           class="fas fa-circle color-Rejected nav-link-hand font-size-14">

                                        </i>
                                      </a>
                                      <a data-toggle="tooltip" data-placement="bottom" title="Pending">
                                        <i *ngSwitchDefault
                                           class="fas fa-circle color-Assign nav-link-hand font-size-14">
                                        </i>
                                      </a>
                                    </div>
                                  </td>
                                  <!--<td class=" td-padding text-align-center">{{l.ApplicationStatus}}-->

                                  <!--<td class=" td-padding text-align-center">
                                    <div class="thick-circle4 nav-link-hand">
                                      <a (click)="openScheduleAssistant(l.JoinByDate)">
                                        <i class="fas fa-ellipsis-h"></i>
                                      </a>
                                    </div>
                                  </td>-->

                                  <td class=" td-padding ">
                                    
                                    <!--<button type="button" *ngIf="l.ApplicationStatus == 'Assigned' "-->
                                    <button type="button" *ngIf="l.ApplicationStatus == 'Released Offer' "
                                            class="btn  actions-btn-prime2 benfits-button font-size border-color">
                                      <i class="fas fa-clock clock-color " hidden></i>
                                    </button>
                                    <button type="button" *ngIf="l.ApplicationStatus == 'Assigned'"
                                            class="btn  actions-btn-prime2 benfits-button font-size border-color">
                                      <i class="fas fa-exchange-alt color-edit-icon" hidden></i>
                                    </button>
                                    <button type="button" *ngIf="l.ApplicationStatus == 'Shift Request' && !l.NurseResponse"
                                            (click)="RaiseAcceptRequest(l)"
                                            class="btn  actions-btn-prime2  font-size border-color padding-button-Accept">
                                      <i class="fas fa-check thick-circle3"></i> Accept 
                                    </button>
                                    <button type="button" *ngIf="l.ApplicationStatus == 'Shift Request' && !l.NurseResponse"
                                            (click)="RaiseRejectRequest(l)"
                                            class="btn  actions-btn-prime2  font-size margin-left-zero border-color padding-button-unavilable">
                                      <i class="fas fa-times color-delete-icon"></i> Unavailable 
                                    </button>
                                    <label class=" td-padding text-align-left">
                                      {{GetShiftStatus(l)}} 
                                    </label>

                                  </td>
                                </tr>

                              </tbody>
                            </table>
                          </div>
                        </div>
                      <!--</div>
                    </div>-->
                   
                 
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      
<router-outlet></router-outlet>


